<style src="./Searchbar.scss" lang="scss"></style>

<script>
	import Input from '@/components/Input/Input';

	export default {
		name: 'HpSearchbar',
		data() {
			return {
				searchbarInput: {
					htmlId: 'searchbar',
					inputType: 'search',
					ariaPlaceholder: 'google', // for identifying search machine
					inputvalue: '',
					name: 'q',
					maxLength: 1024,
					suggest: {
						id: this.$initialData.searchbar.suggestContainerId,
						url: this.$initialData.searchbar.suggestAPI,
						response: ''
					}
				},
				searchURL: this.$initialData.searchbar.searchURL,
				trackParam: {
					v1searchbar: 'HP,exp_hp_01',
					v1suggest: 'HP_sg,exp_hp_02',
					v2searchbar: 'HP,exp_hp_03',
					v2suggest: 'HP_sg,exp_hp_04'
				},
				suggestIndex: -1
			};
		},
		methods: {
			searchSubmit(ev) {
				ev.preventDefault();
				let form = this.$el.querySelector('form') || '';
				let variant = document.querySelector('html').getAttribute('data-variant-name');

				if (form) {
					if (window.getComputedStyle(document.documentElement).getPropertyValue('--screen-touchable') === 'false') {
						if (variant === '2831_variant_1') {
							form.origin.value = this.suggestIndex < 0 ? this.trackParam.v1searchbar : this.trackParam.v1suggest;
						} else if (variant === '2831_variant_2') {
							form.origin.value = this.suggestIndex < 0 ? this.trackParam.v2searchbar : this.trackParam.v2suggest;
						}
					}
					form.submit();
				} else {
					console.log('Form Not Found');
				}
			},
			searchReset() {
				let form = this.$el.querySelector('form') || '';
				form && form.reset();
				this.searchbarInput.inputvalue = '';
			},
			getSuggestIndex(obj) {
				this.suggestIndex = obj.index;
			}
		},
		components: {
			'hp-input': Input
		}
	};
</script>

<template>
	<div data-component="searchbar">
		<form method="get" novalidate="novalidate" :action="searchURL" autocomplete="off">
			<input type="hidden" name="origin" value="HP" />
			<label data-accessibility :for="searchbarInput.htmlId">
				<span>{{ searchbarInput.placeholder }}</span>
			</label>
			<hp-input v-model="searchbarInput" @input="getSuggestIndex" @formsubmit.prevent="searchSubmit" @formreset="searchReset"></hp-input>
		</form>
	</div>
</template>
